export default {
    image: {
        label: 'Image-Upload',
        error: {
            required: 'Please add a picture (JPG, PNG or GIF)'
        }
    },
    color: {
        label: 'Color selection'
    },
    translations: {
        label: 'Title and description',
        locale: {
            de: 'german',
            en: 'english'
        },
        error: {
            invalid_child: 'At least one of the translations has an error',
            one_required: 'At least one translation should be created'
        },
        title: {
            label: 'Title',
            error: {
                required: 'Please enter a title'
            }
        },
        description: {
            label: 'Description',
            error: {
                required: 'Please enter a description'
            }
        }
    },
    active: {
        label: 'Status',
        value: {
            on: 'active',
            off: 'inaktive'
        }
    },
    cancel: 'Cancel',
    submit: 'Submit'
}
